// extracted by mini-css-extract-plugin
var _1 = "DashboardTileValue-modulecount__GyohH";
var _2 = "DashboardTileValue-modulecountSkeleton__ODJHO Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "count", _2 as "countSkeleton" }
